<template>
    <div class="aa">
        <answer-portrait :h5ConfigData="h5ConfigData" :owner="owner"></answer-portrait>
        <div class="default">
            <div class="answer-nav" v-if="faqs && faqs.length > 0">
                <div class="answer-content has-affix">
                    <div class="answer-content-tt">{{ title }}</div>
                    <div class="answer-content-sub">
                        <div class="sub-item" v-for="(faq, index) in faqs" :key="Number(index)" @click="toActive(index)">
                            <img v-if="isImg && faq.subjectIcon" class="sub-i" :src="faq.subjectIcon" alt="" />
                            <div v-else-if="isImg" class="sub-i"></div>
                            <span :class="{ 'active-sub': index === active }">{{ faq.subjectName }}</span>
                        </div>
                    </div>
                    <div v-for="(item, index) in questions" :key="index" class="blue" @click="changeInput(item.questionName)">
                        {{ item.questionName }}
                    </div>
                    <div class="answer-content-affix" v-if="fsl.length > 5">
                        <button type="text" @click.stop="changeBatch"><img src="../../assets/imgs/change.png" alt="change" />换一批</button>
                    </div>
                </div>
            </div>

            <div class="answer-nav menu" v-if="menu && menu.length > 0" :style="{ width: `${clientWidth * 0.88}px`, marginLeft: `-${clientWidth * 0.1}px` }">
                <el-tabs type="border-card" v-model="activeMenu">
                    <el-tab-pane v-for="(subitem, index) in menu" :key="Number(index)">
                        <span slot="label" class="typeName"> {{ subitem.typeName }}</span>
                        <el-carousel trigger="click" height="100px" :autoplay="false" indicator-position="outside">
                            <el-carousel-item v-for="(item, index) in funcListItem" :key="index" class="carousel-item">
                                <div v-for="(_item, _index) in item" :key="_index" class="blue blue-item" @click="changeFuncName(_item)">
                                    <img class="icon" v-if="_item.icon" :src="_item.icon" alt="icon" />
                                    <span class="icon" v-else></span>
                                    <span>{{ _item.funcName }}</span>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import AnswerPortrait from './AnswerPortrait.vue'

export default {
  components: {
    AnswerPortrait
  },
  props: {
    h5ConfigData: {
      type: Object
    },
    owner: String,
    faqs: Array,
    menu: Array,
    title: String
  },
  computed: {
    isImg () {
      const T = this.faqs.filter(f => !f.subjectIcon)
      const FLEN = this.faqs.length
      const LEN = T.length
      return LEN !== FLEN
    }
  },
  data () {
    return {
      active: 0,
      activeMenu: 0,
      questions: [],
      pageSize: 5,
      pageNo: 1,
      fsl: [],
      funcList: [],
      funcListItem: [],
      clientWidth: 0
    }
  },
  beforeMount () {
    this.toActive(0)
    this.clientWidth = document.body.clientWidth
  },
  watch: {
    activeMenu (val) {
      this.funcList = this.menu && this.menu.length > 0 ? this.menu[val].funcList : []
      const aa = function (N, Q) {
        let R = []
        for (let F = 0; F < Q.length;) {
          R.push(Q.slice(F, F += N))
        }
        return R
      }
      this.funcListItem = aa(5, this.funcList)
    }
  },
  methods: {
    toActive (index) {
      this.active = index
      this.pageNo = 1
      this.questions = this.faqs && this.faqs.length > 0 ? this.faqs[index].questions.slice(0, this.pageSize) : []
      this.fsl = this.faqs && this.faqs.length > 0 ? JSON.parse(JSON.stringify(this.faqs[index].questions)) : [] // 控制是否显示"换一批"字样
    },

    changeInput (val) {
      this.$emit('changeInput', val)
    },
    changeFuncName (url) {
      window.location.href = url.url
    },
    // 换一批
    changeBatch () {
      this.pageNo = this.pageNo + 1
      let start = (this.pageNo - 1) * this.pageSize
      const len = this.faqs[this.active].questions.length - 1
      if (start > len) {
        this.pageNo = 1
        start = 0
      }
      const end = this.pageNo * this.pageSize
      this.questions = this.faqs[this.active].questions.slice(start, end)
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
    color: #4e82ff; //111E2E;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    span {
        font-size: 26px;
        font-weight: 400;
        color: #34404d;
        line-height: 36px;
        margin-top: 24px;
    }
    .icon {
        margin-top: 0;
    }
}
.answer-nav {
    margin-bottom: 24px;
}
.menu {
    left: 22px;
    flex: 1;
    right: 22px;
    .answer-content {
        width: 100%;
        max-width: 100%;
    }
}

button {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    padding: 14px 18px 0px;
    border: none;
    text-align: center;
    white-space: nowrap;
    background: #fff;
    -webkit-appearance: none;
    outline: none;
    transition: 0.1s;
    user-select: none;
    cursor: pointer;
    font-size: 28px;
    font-weight: 400;
    color: #4e82ff;
    line-height: 36px;
    &.btn-re {
        border-color: #dcdee0;
        color: #34404d;
    }
    &:active {
        background: #fff;
        border-color: #fff;
        color: #949aa1;
    }
    img {
        width: 32px;
        height: 32px;
    }
}
.answer {
    &-content {
        position: relative;
        width: 560px;
        max-width: 560px;
        padding: 20px 24px 40px;
        line-height: 44px;
        font-size: 32px;
        word-break: break-all;
        word-wrap: word-break;
        color: #111e2e;
        background: #ffffff;
        box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.02);
        border-radius: 12px;
        &-tt {
            padding: 0px 0 24px;
            font-weight: 600;
        }
        &-sub {
            width: 100%;
            max-height: 132px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 20px;
            overflow-y: hidden;
            overflow-x: auto;
            .sub-item {
                cursor: pointer;
                margin-right: 24px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                &:nth-last-of-type() {
                    margin-right: 0;
                }
                .sub-i {
                    width: 70px;
                    height: 70px;
                    border-radius: 4px;
                    // border: 1px dashed #c1b9b9;
                }
                & > span {
                    width: 106px;
                    margin-top: 8px;
                    font-size: 26px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #111e2e;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: center;
                    padding-bottom: 4px;
                }
                .active-sub {
                    color: #4e82ff;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0px;
                        background: #4e82ff;
                        height: 6px;
                        width: 100%;
                        border-radius: 4px;
                    }
                }
            }
        }
        &-affix {
            text-align: center;
            border-top: 1px solid #eaebec;
            margin-top: 16px;
            display: flex;
            justify-content: center;
        }
    }
}
.answerContentSjtu {
    background: #f3f4f6;
    border: none;
}
.el-tab-pane {
    display: flex;
}
.typeName {
    font-size: 26px !important;
    font-weight: 400;
    line-height: 36px !important;
}

.carousel-item {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
}
.blue-item {
    width: 20%;
    display: flex;
    span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    }
    .icon {
        width: 64px;
        height: 64px;
        background: #c5c9d5;
        border-radius: 8px;
    }
}
.icon {
    width: 64px;
    height: 64px;
    background: #c5c9d5;
    border-radius: 8px;
}
</style>
<style scoped>
.menu >>> .el-tabs--border-card {
    border: none;
    box-shadow: none;
}
.menu >>> .el-tabs__content {
    padding: 32px 42px;
}
.menu >>> .el-tabs__item {
    height: 88px;
    font-size: 26px !important;
    font-weight: 400;
    line-height: 36px !important;
    padding: 14px 22px 12px 20px;
    border: none;
    background: #edeff5;
    border-radius: 12px 12px 0px 0px;
}
.menu >>> .el-tabs__header {
    font-size: 36px !important;
    font-weight: 400;
    line-height: 72px !important;
    padding: 0;
    border: none;
    border-radius: 12px 12px 0px 0px;
}
.answer-nav >>> .typeName {
    font-size: 36px !important;
    font-weight: 400;
    line-height: 72px !important;
}
.answer-nav >>> .el-tabs__nav-wrap.is-scrollable {
    padding: 0 36px;
}
.answer-nav >>> .el-tabs__nav-prev {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 100%;
    font-size: 36px;
}
.answer-nav >>> .el-tabs__nav-next {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 100%;
    font-size: 36px;
}
.answer-nav >>> .el-carousel {
    width: 100%;
}
.answer-nav >>> .el-carousel__button {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    color: #c3c7cb;
    background: #c3c7cb;
}
.answer-nav >>> .el-carousel__indicator.is-active button {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    color: #4e82ff;
    background: #4e82ff;
}
.answer-nav >>> .el-carousel__indicator {
    margin-right: 20px;
}
.answer-nav >>> .el-carousel__arrow {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/Answer/AnswerFaq.vue